import { Link } from "react-router-dom";
import { Truck, Wrench, ChevronRight, Tag } from "lucide-react";

export default function Hizmetler() {
  return (
    <div data-testid="hizmetler-page" className="min-h-screen pt-20 sm:pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-white">Hizmetler</h1>
        <p className="mt-2 text-sm text-slate-400">Konumunuza en yakın çekici veya tamirci/servis hizmetine ulaşın.</p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Link data-testid="hizmetler-teklif" to="/teklif-al"
            className="group rounded-2xl border border-emerald-500/30 bg-slate-900/60 backdrop-blur-xl p-7 hover:border-emerald-400/60 hover:shadow-[0_0_28px_rgba(16,185,129,0.15)] transition-all sm:col-span-2">
            <span className="w-12 h-12 rounded-xl bg-emerald-500/10 border border-emerald-500/40 flex items-center justify-center">
              <Tag className="w-6 h-6 text-emerald-300" />
            </span>
            <h2 className="mt-5 text-xl font-bold text-white flex items-center gap-2">
              Teklif Al <ChevronRight className="w-5 h-5 text-slate-600 group-hover:text-emerald-300 transition-colors" />
            </h2>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Araç satışı, servis, cam filmi, yedek parça, çekici ve daha fazlası — talebiniz ilçenizdeki ilgili işletmelere iletilsin, fiyat tekliflerini karşılaştırın.
            </p>
          </Link>

          <Link data-testid="hizmetler-cekici" to="/cekici"
            className="group rounded-2xl border border-orange-500/30 bg-slate-900/60 backdrop-blur-xl p-7 hover:border-orange-400/60 hover:shadow-[0_0_28px_rgba(249,115,22,0.15)] transition-all">
            <span className="w-12 h-12 rounded-xl bg-orange-500/10 border border-orange-500/40 flex items-center justify-center">
              <Truck className="w-6 h-6 text-orange-300" />
            </span>
            <h2 className="mt-5 text-xl font-bold text-white flex items-center gap-2">
              Çekici Çağır <ChevronRight className="w-5 h-5 text-slate-600 group-hover:text-orange-300 transition-colors" />
            </h2>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Arıza, kaza veya yolda kalma durumunda konumunuzla birlikte çekici talebi oluşturun; yakındaki çekiciler anında bilgilendirilsin.
            </p>
          </Link>

          <Link data-testid="hizmetler-servis" to="/servis-bul"
            className="group rounded-2xl border border-cyan-400/30 bg-slate-900/60 backdrop-blur-xl p-7 hover:border-cyan-400/60 hover:shadow-[0_0_28px_rgba(251,146,60,0.15)] transition-all">
            <span className="w-12 h-12 rounded-xl bg-cyan-400/10 border border-cyan-400/40 flex items-center justify-center">
              <Wrench className="w-6 h-6 text-cyan-300" />
            </span>
            <h2 className="mt-5 text-xl font-bold text-white flex items-center gap-2">
              Tamirci / Servis Bul <ChevronRight className="w-5 h-5 text-slate-600 group-hover:text-cyan-300 transition-colors" />
            </h2>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">
              Motor, elektrik, lastik, fren, klima, kaporta ve daha fazlası — kategoriye ve konuma göre onaylı servisleri bulun, talep oluşturun.
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
}
